<template v-if="widgetReady">
    <div>
        <ac-modal title="Assign White Labels" ref="modalRef" :size-class="'modal-md'">
            <template>
                <div class="row">
                    <div class="col-lg-12">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Select</th>
                                    <th>White Label Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="wl in whiteLabels" :key="wl.whiteLabelId">
                                    <td>
                                        <input type="checkbox" class="form-control select-checkbox" v-model="wl.isSelected">
                                    </td>
                                    <td>
                                        <p>{{ wl.name }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>    
                    </div>  
                </div>
                <div class="modal-footer">
                    <div class="button-box">
                        <ac-button class="btn btn-sm btn-red" :action="closeModal">Cancel</ac-button>
                        <ac-button class="btn btn-sm btn-green" :action="save">Save</ac-button>
                    </div>
                </div>
            </template>
        </ac-modal>
        <ac-confirmation-modal ref="confirmModal" :size-class="'modal-md'"
                                :title="'CAUTION'"
                                :accept-button="'CONFIRM'" 
                                :cancel-button="'CANCEL'">
            <p>
                You are removing the whitelabels listed below from the consultant's set of whitelabels. These whitelabels
                are currently being used by at least one company under this consultant.
                <br><br>
                <ol>
                    <li v-for="wl in this.beingDeleted" :key="wl.whiteLabelId">
                        {{ wl.name }}                
                    </li>
                </ol>
                Do you want to proceed?
            </p>
        </ac-confirmation-modal>
    </div>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";
    import {configTables} from "../../../../global/configTables.js";

    export default {
        name: "WhiteLabelModal",
        data() {
            return {
                mediatorId: 0,
                grid: null,
                whiteLabels: [],
                selections: [],
                beingDeleted: [],
                widgetReady: false,
            };
        },
        methods: {
            async showModal(mediatorId) {
                this.mediatorId = mediatorId;
                let mediatorWhitelabels = await api.get('Mediator', mediatorId, 'GetWhiteLabels');
                let assignedWhiteLabelIds = await api.get('Mediator', mediatorId, 'GetAssignedWhiteLabelIds');
                let mediatorWhitelabelIds = mediatorWhitelabels.map(x => x.whiteLabelId);
                this.whiteLabels = await configTables.getWhiteLabelOptions();

                if (mediatorWhitelabelIds != null){
                    this.whiteLabels.forEach(wl => {
                        if(mediatorWhitelabelIds.includes(wl.whiteLabelId)){
                            wl.isSelected = true;
                        }
                        if(assignedWhiteLabelIds.includes(wl.whiteLabelId)){
                            wl.isUsed = true;
                        }
                    });
                }
                this.widgetReady = true;
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async save() {
                for (let i = 0; i < this.whiteLabels.length; i++) {
                    if (!this.whiteLabels[i].isSelected && this.whiteLabels[i].isUsed){
                        this.beingDeleted.push(this.whiteLabels[i]);
                    }
                    if (this.whiteLabels[i].isSelected) {
                        this.selections.push(this.whiteLabels[i].whiteLabelId);
                    }
                }

                let agree = true;
                if(this.beingDeleted.length > 0){
                    agree = false;
                    agree = await this.$refs.confirmModal.showModal();
                }

                if (agree){
                    let whiteLabelIds = JSON.stringify(this.selections);
                    let response = await api.postDataAsJson('Mediator', `${this.mediatorId}/SaveWhiteLabels`, whiteLabelIds);
                    if(response) {
                        this.closeModal();
                    } 
                }               
            },
            getSelections() {
                return this.selections;
            }            
        }
    }
</script>

<style scoped>
.select-checkbox {
    position: unset;
    visibility: visible;
    height: 20px;
    width: 20px;
    margin: 0px 0px 5px;
}

tr,
td,
label {
    vertical-align: unset !important;
}

p {
    margin: 0px 0px 5px;
}
</style>